import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import referralApi from '../../services/referralApi';

// /register?ref=CODE -> referral kodunu okur ve anonim olarak doğrular.
// Geçersiz/eksik kod sessizce yoksayılır (docs/referral-program.md §3).
const useReferralInvite = () => {
  const [searchParams] = useSearchParams();
  const referralcode = (searchParams.get('ref') || '').trim();
  const [referrer, setReferrer] = useState(null);

  useEffect(() => {
    if (!referralcode) return undefined;
    let active = true;
    referralApi
      .validate(referralcode)
      .then((res) => {
        if (active && res.data?.data?.valid) {
          setReferrer(res.data.data);
        }
      })
      .catch(() => {
        // Geçersiz kod / program kapalı / ağ hatası -> sessizce yoksay.
      });
    return () => {
      active = false;
    };
  }, [referralcode]);

  return { referralcode, referrer };
};

export default useReferralInvite;
